import axios from "axios";
import { EXPO_PUBLIC_PAYBOOKS_API_BASE, APP_VERSION, Auth } from "./constants";
import { useAsyncStorage } from '@react-native-async-storage/async-storage';

import * as utils from '@lib/utils';

const {getItem, setItem } = useAsyncStorage('auth');

export const setAuth = async (auth: Auth) => {
  const data = JSON.stringify(auth);
  await setItem(data);
  utils.reloadApp();
};

export const getAuth = async ():Promise<Auth> =>  {
  const auth = await getItem() || "null";
  return JSON.parse(auth);
};

export const logout = async () => {
  await setAuth(null);
};

// Create a new instance of axios with the baseURL set to the EXPO_PUBLIC_PAYBOOKS_API_BASE.
// This is mainly used bu useRest hook.
export const getInstance = async () => {
  const auth = await getAuth();
  // const auth = {};

  const config = {
    baseURL: EXPO_PUBLIC_PAYBOOKS_API_BASE,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      "Authorization": auth ? `Bearer ${auth?.token}` : undefined,
      "AppVersion": APP_VERSION
    },
  };

  const instance = axios.create(config);

  // Set up an interceptor to extract the `data` attribute from the response,
  // or clear the token if it's expired or invalid
  instance.interceptors.response.use(
    // Return only the data
    (response) => response.data,

    // Handle errors
    async (error) => {
      const status = error?.response?.status;
      const auth = await getAuth();
      // If we store an expired or invalid token, reset the auth to null and reload the app
      // Moreover, only logout and reload the app if there is an expire token
      // Otherwise, the app will reload indefinitely.
      if (status === 401 && (auth != null)) { 
        // logging out reset the auth and reload the app
        await logout();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default async (data: any) => (await getInstance())(data);